<script>
import forminput from "@/router/views/formcomponet/forminput.vue"; 
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import Drawer from "vue-simple-drawer";
import AddEdit from "./addedit.vue";
import register from "@/models/register";
import Swal from "sweetalert2";

export default {
  mixins: [apibtoast, apigeneric,register],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    PageHeader,
    AddEdit,
    Drawer, 
    forminput,
  },
  data() {
    return {
      title: this.$t("mznmezunlar.Title"),
      items: [
        {
          text: this.$t("mznmezunlar.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("mznmezunlar.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FilitrelemePenceresi: false,
      Filter: {
        Adisoyadi: "",
        Eposta: "",
        Tckimlikno: "",
        Telefon: "", 
      }, 
    };
  },
  validations: {
    Filter: {
      Adisoyadi: {},
      Eposta: {},
      Tckimlikno: {},
      Telefon: {}, 
    },
  },
  methods: {
    MznOnay(Data){ 
      var FormData = this.registerData
      FormData.FirstName= Data.Adisoyadi 
      FormData.Email= Data.Eposta
      FormData.UserName= Data.Eposta
      FormData.LastName= Data.Adisoyadi 
      FormData.Password= Data.Tckimlikno.toString().substr(0,5)+Data.Adisoyadi.substr(0,3)+'.';
      FormData.ConfirmPassword= Data.Tckimlikno.toString().substr(0,5)+Data.Adisoyadi.substr(0,3)+'.';
    
     
      this.Post(this.$config.API_ACCOUNT_URL_2+"Account/register", FormData,this.$t("mznfirma.Page.OnayMessage")).then((res) => {
            if (res) {
  
              Data.Userid=res
              Data.Onay=true
              this.Update(this.$config.API_URL_2+"mznmezunlar", Data) 
            }
          }); 

    },
    UserDelete(Data){ 
      Swal.fire({
        title: this.$t("ToasMessage.DeletePopupBaslik"),
        text: this.$t("ToasMessage.DeletePopupContent"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: this.$t("ToasMessage.DeletePopupPozitif"),
        cancelButtonText: this.$t("ToasMessage.DeletePopupNegatif"),
      }).then((result) => {
        if (result.value) {
          this.ActionsDelete({ Service: this.$config.API_URL_2+"mznmezunlar", Id: Data.Id }).then((res) => {
            if (res.Succeeded == true) {
    
                  this.$toast.success(this.$t("ToasMessage.DeletePozitif"));
                  this.ActionsDelete({Service: this.$config.API_ACCOUNT_URL_2+"Account", Id: Data.Userid}).then((res) => {
                    if(res.Succeeded == true){
                      this.Get();
                    }
      });
  
              
            } else {
              this.$toast.error(this.$t("ToasMessage.DeleteNegatif"));
            }
          });
        }
      });

        },
    
    Get() {
      let Filter =
        "&Adisoyadi=" +
        this.Filter.Adisoyadi +
        "&Eposta=" +
        this.Filter.Eposta +
        "&Tckimlikno=" +
        this.Filter.Tckimlikno +
        "&Telefon=" +
        this.Filter.Telefon 
      this.ActionsFilterGet({
        Service: this.$config.API_URL_2+"mznmezunlar",
        Page: this.Page,
        Filter: Filter,
      }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
      });
    },
    rightDrawer() {
      this.FilitrelemePenceresi = !this.FilitrelemePenceresi;
    },
  }, 
  created(){ 
     
  
  
  }
};
</script>

<template>
  <Loader>
    <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <div class="row mb-2">
                <div class="col-sm-12">
                  <div class="text-sm-end">
                    <button
                      type="button"
                      class="btn btn-secondary btn-rounded mb-2 me-2"
                      @click="rightDrawer"
                    >
                      <i class="mdi mdi-text-search me-1"></i>
                      {{ $t("mznmezunlar.Page.Filtreleme") }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table mb-0">
                  <thead class="table-light">
                    <tr>
                      <th>{{ $t("mznmezunlar.Table.Adisoyadi") }}</th>
                      <th>{{ $t("mznmezunlar.Table.Eposta") }}</th>
                      <th>{{ $t("mznmezunlar.Table.Telefon") }}</th>
                      <th>{{ $t("mznmezunlar.Table.Islem") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="Data in TableData" :key="Data.Id">
                      <td>{{ Data.Adisoyadi }}</td>
                      <td>{{ Data.Eposta }}</td>
                      <td>{{ Data.Telefon }}</td>
                      <td style="width: 100px; text-align: center">
                        <b-button-group>
                          <b-button v-if="!Data.Onay " variant="warning" v-tooltip="$t('mznmezunlar.Table.Onay')" 
                          @click="MznOnay(Data)">
                            <i class="fas fa-check-double"></i>
                          </b-button>
                          <b-button
                            variant="success"
                            v-b-modal.mznmezunlar
                            @click="(DataUpdate = Data), (AddEdit = 'Edit')"
                            ><i class="far fa-edit"></i
                          ></b-button>
                          <b-button
                            variant="danger"
                            @click="UserDelete(Data)"
                            ><i class="far fa-trash-alt"></i
                          ></b-button> 
                        </b-button-group>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <br />
                <b-pagination
                  class="pagination pagination-rounded justify-content-end mb-2"
                  v-model="DefaultPage"
                  :total-rows="Page.PageDataSize"
                  :per-page="Page.PageSize"
                  aria-controls="my-table"
                  @input="ChangePage(DefaultPage)"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEdit
        :Id="DataUpdate"
        :AddEdit="AddEdit"
        @TableUpdate="Get()"
        v-show="DataUpdate"
      />

      <Drawer
        @close="rightDrawer"
        :align="'right'"
        :closeable="true"
        :maskClosable="true"
        :zIndex="1002"
      >
        <div v-if="FilitrelemePenceresi">
          <div class="offcanvas-header">
            <h5 class="offcanvas-title" id="offcanvasExampleLabel">
              {{ $t("mznmezunlar.Filtreleme.Title") }}
            </h5>
          </div>
          <div class="offcanvas-body">
            {{ $t("mznmezunlar.Filtreleme.Content") }}
            <div class="mb-3 mt-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Adisoyadi',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Adisoyadi'),
                }"
                :Value="Filter.Adisoyadi"
                :v="$v.Filter.Adisoyadi"
                @input="Filter.Adisoyadi = $event"
              />
            </div>
            <div class="mb-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Eposta',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Eposta'),
                }"
                :Value="Filter.Eposta"
                :v="$v.Filter.Eposta"
                @input="Filter.Eposta = $event"
              />
            </div>
            <div class="mb-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Tckimlikno',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Tckimlikno'),
                }"
                :Value="Filter.Tckimlikno"
                :v="$v.Filter.Tckimlikno"
                @input="Filter.Tckimlikno = $event"
              />
            </div>
            <div class="mb-3">
              <forminput
                :FormDataType="{
                  FieldName: 'Telefon',
                  Field: 'input',
                  FieldTitle: $t('mznmezunlar.Filtreleme.Telefon'),
                }"
                :Value="Filter.Telefon"
                :v="$v.Filter.Telefon"
                @input="Filter.Telefon = $event"
              />
            </div>
          

            <b-button
              @click="Get()"
              class="btn btn-primary"
              variant="primary"
              >{{ $t("mznmezunlar.Filtreleme.Button") }}</b-button
            >
          </div>
        </div>
      </Drawer>
    </Layout>
  </Loader>
</template>
